// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { imageBadgeStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsImageBadge";
import { css } from "styled-components";

imageBadgeStyles.container = {
    css: css`
        margin-top: 12px;
        display: flex;
        gap: 8px 16px;
        flex-wrap: wrap;
    `,
};
imageBadgeStyles.imageContainer = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        column-gap: 16px;
        row-gap: 8px;
    `,
};
